import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "./assets/Burakyol-logo.jpeg";
import uskudarMain from "./assets/uskudar/uskudar.jpeg";
import kartalMain from "./assets/kartal/kartal-kentsel-donusum (1).jpg";
import kiptasMain from "./assets/kiptas/kiptas.jpg";
import marmaraMain from "./assets/marmara/musilaj.webp";
import dursunkoyMain from "./assets/dursunkoy-okul/dursunkoy-okul.jpeg";

const Projects = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [activeCategory, setActiveCategory] = useState("all");

    const categories = [
        { id: "all", name: "Tümü", icon: <path strokeLinecap="round" strokeLinejoin="round" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" /> },
        { id: "ustyapi", name: "Üstyapı", icon: <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /> },
        { id: "altyapi", name: "Altyapı", icon: <path strokeLinecap="round" strokeLinejoin="round" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /> },
        { id: "kentsel", name: "Kentsel Dönüşüm", icon: <path strokeLinecap="round" strokeLinejoin="round" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" /> }
    ];

    const projects = [
        {
            id: 1,
            title: "Üsküdar Kentsel Dönüşüm Projesi",
            category: "kentsel",
            status: "completed",
            progress: 100,
            image: uskudarMain,
            location: "İstanbul, Üsküdar",
            year: "2023",
            description: "320 daireli kentsel dönüşüm projesi"
        },
        {
            id: 2,
            title: "Kartal Kentsel Dönüşüm Projesi",
            category: "kentsel",
            status: "ongoing",
            progress: 73,
            image: kartalMain,
            location: "İstanbul, Kartal",
            year: "2024",
            description: "Kartal ilçesi, orhantepe mahallesi 2.Etap kentsel dönüşüm projesi inşaatı."
        },
        {
            id: 3,
            title: "Kiptaş Çatalca Erguvankent Konutları",
            category: "altyapi",
            status: "completed",
            progress: 100,
            image: kiptasMain,
            location: "İstanbul, Çatalca",
            year: "2016",
            description: "Kiptaş Çatalca Erguvankent Konutları altyapı projesi."
        },
        {
            id: 4,
            title: "Marmara Müsilaj Temizleme Projesi",
            category: "altyapi",
            status: "completed",
            progress: 100,
            image: marmaraMain,
            location: "Marmara Denizi",
            year: "2021",
            description: "Marmara Denizi müsilaj temizleme ve çevre koruma projesi."
        },
        {
            id: 5,
            title: "Dursunköy Okul Yapımı Projesi",
            category: "ustyapi",
            status: "ongoing",
            progress: 0,
            image: dursunkoyMain,
            location: "İstanbul, Dursunköy",
            year: "2026",
            description: "Dursunköy ilçesi, okul yapımı projesi inşaatı."
        }
    ];

    const filteredProjects = activeCategory === "all" 
        ? projects 
        : projects.filter(p => p.category === activeCategory);

    return (
        <div className="min-h-screen bg-white">
            {/* Logo */}
            <div className="hidden xl:block absolute left-[15vw] 2xl:left-[22vw] 3xl:left-[28rem] top-[60px] -translate-y-1/2 z-40 pointer-events-auto w-[80px] h-[80px] 2xl:w-[90px] 2xl:h-[90px] 3xl:w-[100px] 3xl:h-[100px] rounded-full flex items-center justify-center shrink-0 overflow-hidden shadow-xl">
                <img src={logo} alt="Logo" className="w-full h-full object-cover" />
            </div>
        
            {/* Navbar */}
            <header className="fixed top-[12px] md:top-[24px] left-0 right-0 z-50 flex items-center justify-center px-4 md:px-sm w-full pointer-events-none">
                <div className="pointer-events-auto w-full max-w-[700px] h-[60px] md:h-[72px] flex items-center justify-between bg-[#01346b] backdrop-blur-xl rounded-full px-4 md:px-xs py-xs shadow-xl border border-white/10">
                    <div className="flex items-center gap-4 pl-2 md:pl-xs">
                        <div className="md:hidden w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                            <img src={logo} alt="Logo" className="w-full h-full object-cover" />
                        </div>
                        
                        <nav className="hidden md:flex items-center gap-6 pl-4">
                            <Link to="/hakkimizda" className="font-label text-label text-page-bg/80 hover:text-page-bg transition-colors duration-300">Hakkımızda</Link>
                            <Link to="/projeler" className="font-label text-label text-page-bg hover:text-page-bg transition-colors duration-300">Projeler</Link>
                            <Link to="/hizmetler" className="font-label text-label text-page-bg/80 hover:text-page-bg transition-colors duration-300">Hizmetler</Link>
                            <Link to="/iletisim" className="font-label text-label text-page-bg/80 hover:text-page-bg transition-colors duration-300">İletişim</Link>
                        </nav>
                        
                        <button 
                            className="md:hidden text-white p-14"
                            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                            aria-label="Toggle menu"
                        >
                            {mobileMenuOpen ? (
                                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            ) : (
                                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            )}
                        </button>
                    </div>
                    <Link to="/" className="bg-page-bg text-black font-label text-sm md:text-label h-full px-4 md:px-8 rounded-full hover:bg-white transition-colors duration-300 scale-95 hover:scale-100 shrink-0 flex items-center shadow-sm">
                        Anasayfa
                    </Link>
                </div>

                <div 
                    className={`md:hidden absolute top-[72px] left-4 right-4 bg-[#01346b] backdrop-blur-xl rounded-3xl shadow-2xl border border-white/10 overflow-hidden pointer-events-auto transition-all duration-500 ease-out ${
                        mobileMenuOpen 
                            ? 'opacity-100 translate-y-0 max-h-96' 
                            : 'opacity-0 -translate-y-4 max-h-0 pointer-events-none'
                    }`}
                >
                    <nav className="flex flex-col p-4">
                        <Link to="/hakkimizda" className="text-white py-4 px-4 hover:bg-white/10 rounded-xl transition-all duration-300 font-medium transform hover:translate-x-2" onClick={() => setMobileMenuOpen(false)}>Hakkımızda</Link>
                        <Link to="/projeler" className="text-white py-4 px-4 hover:bg-white/10 rounded-xl transition-all duration-300 font-medium transform hover:translate-x-2" onClick={() => setMobileMenuOpen(false)}>Projeler</Link>
                        <Link to="/hizmetler" className="text-white py-4 px-4 hover:bg-white/10 rounded-xl transition-all duration-300 font-medium transform hover:translate-x-2" onClick={() => setMobileMenuOpen(false)}>Hizmetler</Link>
                        <Link to="/iletisim" className="text-white py-4 px-4 hover:bg-white/10 rounded-xl transition-all duration-300 font-medium transform hover:translate-x-2" onClick={() => setMobileMenuOpen(false)}>İletişim</Link>
                    </nav>
                </div>
            </header>

            {/* Hero Section */}
            <section className="relative min-h-[70vh] md:min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#01346b] via-[#01346b] to-[#024a8f] pt-24 md:pt-32">
                <div className="absolute inset-0 opacity-10">
                    <div className="absolute top-20 left-20 w-72 h-72 bg-white rounded-full blur-3xl animate-pulse"></div>
                    <div className="absolute bottom-20 right-20 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
                </div>

                <div className="absolute inset-0 opacity-5" style={{
                    backgroundImage: 'linear-gradient(white 1px, transparent 1px), linear-gradient(90deg, white 1px, transparent 1px)',
                    backgroundSize: '50px 50px'
                }}></div>

                <div className="max-w-[1200px] mx-auto px-4 md:px-8 relative z-10 text-center py-8 md:py-20">
                    <div className="inline-flex items-center gap-2 px-4 md:px-6 py-2 md:py-3 bg-white/20 backdrop-blur-md rounded-full mb-6 md:mb-8 animate-fade-in-down">
                        <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                        <span className="text-white text-xs md:text-sm font-semibold tracking-wider">PROJELERİMİZ</span>
                    </div>
                    
                    <h1 className="font-display text-3xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-4 md:mb-6 leading-tight animate-fade-in" style={{ animationDelay: '0.2s' }}>
                        Hayata Geçirdiğimiz<br />
                        <span className="bg-gradient-to-r from-white to-white/80 bg-clip-text text-transparent">Başarı Hikayeleri</span>
                    </h1>
                    
                    <p className="text-base md:text-xl lg:text-2xl text-white/90 max-w-3xl mx-auto leading-relaxed mb-8 md:mb-16 animate-fade-in px-4" style={{ animationDelay: '0.4s' }}>
                        Her proje, kalite ve mükemmellik anlayışımızın somut bir yansımasıdır
                    </p>

                    {/* Stats Grid */}
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6 lg:gap-8 max-w-5xl mx-auto animate-fade-in" style={{ animationDelay: '0.6s' }}>
                        {[
                            {
                                value: "50+",
                                label: "Tamamlanan Proje",
                                icon: (
                                    <svg className="w-6 h-6 md:w-8 md:h-8 lg:w-10 lg:h-10 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                    </svg>
                                ),
                                color: "from-blue-400 to-blue-600"
                            },
                            {
                                value: "100K+",
                                label: "m² İnşaat Alanı",
                                icon: (
                                    <svg className="w-6 h-6 md:w-8 md:h-8 lg:w-10 lg:h-10 text-emerald-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                                    </svg>
                                ),
                                color: "from-emerald-400 to-emerald-600"
                            },
                            {
                                value: "100+",
                                label: "Çalışan",
                                icon: (
                                    <svg className="w-6 h-6 md:w-8 md:h-8 lg:w-10 lg:h-10 text-orange-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                    </svg>
                                ),
                                color: "from-orange-400 to-orange-600"
                            },
                            {
                                value: "10+",
                                label: "Yıllık Tecrübe",
                                icon: (
                                    <svg className="w-6 h-6 md:w-8 md:h-8 lg:w-10 lg:h-10 text-purple-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                ),
                                color: "from-purple-400 to-purple-600"
                            }
                        ].map((stat, idx) => (
                            <div 
                                key={stat.label}
                                className="group relative bg-white/10 backdrop-blur-md rounded-2xl md:rounded-3xl p-4 md:p-6 lg:p-8 border border-white/20 hover:bg-white/20 hover:border-white/40 transition-all duration-500 hover:scale-105"
                                style={{ animationDelay: `${0.7 + idx * 0.1}s` }}
                            >
                                <div className="flex flex-col items-center text-center">
                                    <div className={`mb-2 md:mb-4 group-hover:scale-110 transition-all duration-300`}>
                                        {stat.icon}
                                    </div>
                                    <div className="font-display text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-1 md:mb-2">
                                        {stat.value}
                                    </div>
                                    <p className="text-white/80 text-xs md:text-sm lg:text-base font-medium">
                                        {stat.label}
                                    </p>
                                </div>
                                
                                {/* Decorative element */}
                                <div className={`absolute inset-0 rounded-3xl bg-gradient-to-br ${stat.color} opacity-0 group-hover:opacity-10 transition-opacity duration-500`}></div>
                            </div>
                        ))}
                    </div>

                    {/* Scroll Indicator */}
                    <div className="animate-bounce mt-8 md:mt-16">
                        <svg className="w-5 h-5 md:w-6 md:h-6 text-white/70 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                        </svg>
                    </div>
                </div>

                <style jsx>{`
                    @keyframes fade-in-down {
                        from {
                            opacity: 0;
                            transform: translateY(-20px);
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }
                    
                    @keyframes fade-in {
                        from {
                            opacity: 0;
                        }
                        to {
                            opacity: 1;
                        }
                    }

                    .animate-fade-in-down {
                        animation: fade-in-down 0.8s ease-out;
                    }

                    .animate-fade-in {
                        animation: fade-in 1s ease-out;
                    }
                `}</style>
            </section>

            {/* Category Filter */}
            <section className="py-12 bg-[#f8f9fa] border-b border-gray-200">
                <div className="max-w-[1200px] mx-auto px-4 md:px-8">
                    <div className="grid grid-cols-2 md:flex md:flex-wrap md:justify-center gap-3 md:gap-4">
                        {categories.map(cat => (
                            <button
                                key={cat.id}
                                onClick={() => setActiveCategory(cat.id)}
                                className={`group flex items-center justify-center gap-2 md:gap-3 px-4 md:px-6 py-3 rounded-2xl font-semibold text-xs md:text-base transition-all duration-300 ${
                                    activeCategory === cat.id
                                        ? 'bg-gradient-to-r from-[#01346b] to-[#024a8f] text-white shadow-lg scale-105'
                                        : 'bg-white text-gray-700 hover:bg-gray-50 hover:shadow-md border border-gray-200'
                                }`}
                            >
                                <svg className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                    {cat.icon}
                                </svg>
                                <span className="truncate">{cat.name}</span>
                                {activeCategory === cat.id && (
                                    <span className="hidden md:inline-block bg-white/20 text-white text-xs font-bold px-2 py-1 rounded-full flex-shrink-0">
                                        {filteredProjects.length}
                                    </span>
                                )}
                            </button>
                        ))}
                    </div>
                </div>
            </section>

            {/* Projects Grid */}
            <section className="py-20 md:py-32 bg-white">
                <div className="max-w-[1200px] mx-auto px-4 md:px-8">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {filteredProjects.map((project, idx) => (
                            <div 
                                key={project.id}
                                className="group relative bg-white rounded-3xl overflow-hidden border-2 border-gray-100 hover:border-[#01346b]/30 hover:shadow-2xl transition-all duration-500"
                                style={{ animationDelay: `${idx * 100}ms` }}
                            >
                                {/* Image */}
                                <div className="relative h-64 overflow-hidden">
                                    <img 
                                        src={project.image} 
                                        alt={project.title}
                                        className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                                    
                                    {/* Status Badge */}
                                    <div className="absolute top-4 right-4">
                                        <span className={`px-4 py-2 rounded-full text-xs font-bold backdrop-blur-md ${
                                            project.status === 'completed' 
                                                ? 'bg-emerald-500/90 text-white' 
                                                : 'bg-amber-500/90 text-white'
                                        }`}>
                                            {project.status === 'completed' ? 'Tamamlandı' : 'Devam Ediyor'}
                                        </span>
                                    </div>

                                    {/* Category Icon */}
                                    <div className="absolute bottom-4 left-4">
                                        <div className="w-12 h-12 bg-white/20 backdrop-blur-md rounded-xl flex items-center justify-center">
                                            <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                                {categories.find(c => c.id === project.category)?.icon}
                                            </svg>
                                        </div>
                                    </div>
                                </div>

                                {/* Content */}
                                <div className="p-6">
                                    <div className="flex items-center gap-2 mb-3">
                                        <svg className="w-4 h-4 text-[#01346b]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                        </svg>
                                        <span className="text-sm text-gray-600 font-medium">{project.location}</span>
                                    </div>

                                    <h3 className="font-display text-xl font-bold text-gray-900 mb-2 group-hover:text-[#01346b] transition-colors">
                                        {project.title}
                                    </h3>
                                    
                                    <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                                        {project.description}
                                    </p>

                                    <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                                        <span className="text-xs text-gray-500 font-medium">{project.year}</span>
                                        <Link 
                                            to={`/projeler/${project.id}`}
                                            className="flex items-center gap-2 text-[#01346b] font-semibold text-sm group-hover:gap-3 transition-all duration-300"
                                        >
                                            <span>Detaylar</span>
                                            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                            </svg>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Empty State */}
                    {filteredProjects.length === 0 && (
                        <div className="text-center py-20">
                            <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
                                <svg className="w-12 h-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                            </div>
                            <h3 className="font-display text-2xl font-bold text-gray-900 mb-2">Proje Bulunamadı</h3>
                            <p className="text-gray-600">Bu kategoride henüz proje bulunmamaktadır</p>
                        </div>
                    )}
                </div>
            </section>

        </div>
    );
};

export default Projects;
